import { render } from "./PdfComponent.vue?vue&type=template&id=5abef26c"
import script from "./PdfComponent.vue?vue&type=script&lang=js"
export * from "./PdfComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/buttons/export/PdfComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5abef26c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5abef26c', __exports__)) {
    api.reload('5abef26c', __exports__)
  }
  
  module.hot.accept("./PdfComponent.vue?vue&type=template&id=5abef26c", () => {
    api.rerender('5abef26c', render)
  })

}


export default __exports__